<template>
  <div class="navigation" :class="pageData.headerStyle == 2 ? 'navigationActive' : ''">
    <div class="content">
      <div class="sideLeft">
        <div class="logo" @click="pageJump('homePage')">
          <img src="@/assets/images/logo.png" alt="logo" />
        </div>

        <div class="navList">
          <div v-for="item in pageData.navList" :key="item" @click="pageJump(item.path)">
            {{ item.title }}
          </div>
        </div>
      </div>

      <div class="sideContent">
        <!-- <div
          :class="headerStyle == 2 ? 'searchWap' : 'searchWapStyle searchWap'"
        >
          <img :src="headerStyle == 2 ? searchIconActive : searchIcon" />
          <input
            type="search"
            v-model="searchValue"
            placeholder="请输入搜索内容"
          />
        </div> -->
        <div class="sideContentRight">
          <div class="theBtnView" v-if="pageData.isLogin">
            <div :style="{ background: pageData.headerStyle == 2 ? '' : '#fff' }" @click="pageJump('/registered')">
              注册
            </div>
            <div @click="pageJump('/login')">登录</div>
          </div>
          <div class="theBtnView" v-else>
            <div @click="pageJump('/')">管理中心</div>
            <div @click="logOut">退出登录</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Cookies from "js-cookie";

export default {
  name: "navigation",
  setup(prop) {
    console.log(prop);
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    let pageData = reactive({
      router: "",
      isLogin: true,
      headerStyle: 1,
      navList: [
        {
          title: "版权确权登记",
          path: "copyrightConfirmationRegistration"
        },
        {
          title: "智能投稿",
          path: "intelligentContribute"
        },
        {
          title: "维权服务",
          path: "rightsProtectionService"
        },
        // {
        //   title: "版权帮助中心",
        //   path: "copyrightHelpCentre"
        // },
        {
          title: "购买版权",
          path: "buyCopyright"
        },
      ]
    });
    pageData.isLogin = store.state.isLogin;
    const pageJump = (e) => {
      console.log(store.state.isLogin)
      if(e == 'homePage' && !store.state.isLogin){
        e = 'homeStartingPage'
      }
      router.push(e);
    };
    watch(
      () => store.state.isLogin,
      (data) => {
        pageData.isLogin = data;
      }
    );
    watch(
      () => route.path,
      (value) => {
        if (value == "/login") {
          pageData.headerStyle = 1;
        } else {
          pageData.headerStyle = 2;
        }
      }
    );

    let routers = reactive(router);
    watch(routers, (newValue) => {
      pageData.router = newValue.currentRoute.path;
    });
    function logOut() {
      Cookies.remove("userInformation");
      store.commit("isLoginSetting", true);
      router.push({
        path: "/userAccountSettings",
      });
    }
    return {
      pageJump,
      pageData,
      logOut,
    };
  },
};
</script>

<style lang='scss' scoped>
.navigationActive {
  border-bottom: 1px solid #e6e6e6 !important;
  background: #fff !important;
}

.navigation {
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;

  .content {
    width: 1380px;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .sideContent {
      border-radius: 6px;
      display: flex;
      align-items: center;

      .sideContentRight {
        display: flex;
        align-items: flex-end;

        .mR {
          margin-right: 16px;
        }

        .managementBtn {
          width: 68px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: #008aea;
          border-radius: 8px;
          color: #fff;
          font-size: 14px;
          cursor: pointer;
          margin-left: 32px;
        }

        .theBtnView {
          display: flex;
          align-items: center;
          margin-left: 32px;

          div {
            width: 68px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #f5f7fa;
            border-radius: 8px;
            color: #303133;
            font-size: 14px;
            cursor: pointer;
          }

          div:last-of-type {
            background: #008aea;
            color: #fff;
            margin-left: 16px;
          }
        }
      }

      .searchWapStyle {
        background: rgba(255, 255, 255, 0.2) !important;
        color: #ffffff !important;
        border: none !important;
      }

      .searchWap {
        width: 156px;
        height: 40px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        background: #ffffff;
        border: 1px solid #cccccc;

        input::-webkit-input-placeholder {
          color: #ccc;
        }

        img {
          width: 24px;
          height: 24px;
        }

        input {
          width: 120px;
          outline: none;
          background: none;
          border: none;
          font-size: 13px;
          font-family: AlibabaPuHuiTiR;
        }
      }
    }

    .sideLeft {
      display: flex;
      align-items: center;

      .navList {
        display: flex;
        align-items: center;

        div {
          font-size: 13px;
          font-family: AlibabaPuHuiTiM;
          color: #909399;
          margin-right: 20px;
          cursor: pointer;
        }
        div:last-of-type{
          margin: 0;
        }
      }

      .logo {
        width: 200px;
        height: 60px;
        cursor: pointer;

        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
